// File: src/pages/JobDetailPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import '../css/JobDetailPage.css'; // Giữ CSS cũ, nhưng sẽ override bằng inline style để fix lỗi
import UpgradeRequestModal from '../components/UpgradeRequestModal';

// --- ICONS SVG ---
const IconHeart = ({ filled }) => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill={filled ? "#EF4444" : "none"} stroke={filled ? "#EF4444" : "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>);
const IconChevronRight = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>;
const IconShare = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>;
const IconMoney = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>;
const IconMap = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;
const IconBriefcase = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>;
const IconLaptop = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>;
const IconUpload = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>;
const IconQuiz = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>;
const IconUsers = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const IconArrowRightBig = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>;
const IconDomain = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>;
const IconCheckCircle = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const IconRobotHead = () => <span className="material-symbols-outlined" style={{fontSize: 18}}>smart_toy</span>;
// --- TOAST COMPONENT ---
const Toast = ({ message, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 5000); // Tăng lên 5s để user kịp bấm nút
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div style={{
            position: 'fixed', bottom: '24px', left: '24px', zIndex: 10000,
            background: '#1F2937', color: 'white', padding: '16px 20px', borderRadius: '12px',
            display: 'flex', alignItems: 'flex-start', gap: '12px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2)',
            fontSize: '14px', animation: 'slideUpToast 0.3s ease-out',
            borderLeft: '4px solid #F59E0B' // Màu vàng cảnh báo
        }}>
            <span className="material-symbols-outlined" style={{ color: '#F59E0B', fontSize: '24px' }}>warning</span>
            <div style={{ flex: 1 }}>
                {message} 
            </div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#9CA3AF', cursor: 'pointer' }}>
                <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>close</span>
            </button>
        </div>
    );
};

export default function JobDetailPage() {
    const { id } = useParams();
    const [job, setJob] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('desc');
    const [isSaved, setIsSaved] = useState(false);

    // STATE
    const [applicationStatus, setApplicationStatus] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [toast, setToast] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
    const [usage, setUsage] = useState(null);
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    const [aiMatch, setAiMatch] = useState(null); // State lưu kết quả AI
    const [aiLoading, setAiLoading] = useState(false);

    useEffect(() => {
        const fetchJobDetail = async () => {
            // ✅ QUAN TRỌNG: Reset trạng thái để tránh dính dữ liệu của Job cũ
            setApplicationStatus(null); 
            setIsSaved(false);
            setLoading(true);

            try {
                const response = await fetch(`${apiBaseUrl}/api/jobs/${id}`);
                const data = await response.json();
                setJob(data);

                const token = localStorage.getItem('skillmatch_token');
                if (token) {
                    // Kiểm tra trạng thái ứng tuyển cụ thể cho Job ID này
                    const statusRes = await fetch(`${apiBaseUrl}/api/candidates/check-status/${id}`, {
                        headers: { 'x-auth-token': token }
                    });
                    if (statusRes.ok) {
                        const statusData = await statusRes.json();
                        // ✅ FIX: Chỉ set status nếu đúng là đã ứng tuyển Job này
                        if (statusData.applied) setApplicationStatus(statusData.status);
                    }

                    const userRes = await fetch(`${apiBaseUrl}/api/users/me/interactions`, {
                        headers: { 'x-auth-token': token }
                    });
                    if (userRes.ok) {
                        const userData = await userRes.json();
                        if (userData.savedJobs.includes(id)) setIsSaved(true);
                    }

                    const usageRes = await fetch(`${apiBaseUrl}/api/ai/usage`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (usageRes.ok) setUsage(await usageRes.json());
                }
            } catch (error) { console.error(error); }
            finally { setLoading(false); }
        };
        fetchJobDetail();
    }, [id, apiBaseUrl]);
    

    const showToastMsg = (msg) => setToast(msg);
    const isExpired = job?.endDate && new Date() > new Date(job.endDate);

    const handleSaveJob = async () => {
        const token = localStorage.getItem('skillmatch_token');
        if (!token) return navigate('/login');

        try {
            const res = await fetch(`${apiBaseUrl}/api/users/toggle-job/${id}`, {
                method: 'PUT',
                headers: { 'x-auth-token': token }
            });
            const data = await res.json();

            if (res.ok) {
                setIsSaved(data.saved);
                showToastMsg(data.message);
            }
        } catch (error) { console.error("Lỗi lưu job:", error); }
    };
    const handleFetchAIMatch = async () => {
        const token = localStorage.getItem('skillmatch_token');
        if (!token) return navigate('/login');
        
        // Nếu user FREE -> Chặn tính năng này (Upsell)
        if (usage?.plan === 'free') {
            setShowUpgradeModal(true);
            return;
        }

        if (aiMatch) return; // Đã có dữ liệu thì ko gọi lại

        setAiLoading(true);
        try {
            const res = await fetch(`${apiBaseUrl}/api/ai/match-job`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ jobId: id })
            });
            const data = await res.json();
            if (res.ok) setAiMatch(data);
        } catch (e) { console.error(e); }
        finally { setAiLoading(false); }
    };

    
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        
        if (tabId === 'ai_match') {
            // Nếu là Tab AI -> Gọi API, không scroll vì nó sẽ thay thế toàn bộ view
            handleFetchAIMatch();
        } else {
            // Nếu là 3 Tab thường -> Cuộn xuống section tương ứng
            // setTimeout để đảm bảo DOM đã render lại (nếu đang ở tab AI quay về)
            setTimeout(() => {
                const element = document.getElementById(`section-${tabId}`);
                if (element) {
                    // Trừ đi 180px để tránh bị Header che mất
                    const headerOffset = 180;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
            }, 50);
        }
    };

    const handleApply = async () => {
    const token = localStorage.getItem('skillmatch_token');
    if (!token) return navigate('/login');
    if (applicationStatus) return;

    // Kiểm tra giới hạn gói cước
    if (usage?.plan === 'free' && usage?.apply?.used >= 3) {
        setShowUpgradeModal(true);
        return;
    }

    try {
        // 1. Lấy thông tin profile mới nhất để kiểm tra
        const userRes = await fetch(`${apiBaseUrl}/api/users/profile`, { 
            headers: { 'x-auth-token': token } 
        });
        const userData = await userRes.json();
        const profile = userData.profile || {};

        // 2. LOGIC KIỂM TRA THÔNG TIN QUAN TRỌNG
        const isMissingInfo = 
            !profile.fullName || 
            !(profile.phoneNumber || userData.phone) || 
            !userData.skills?.length || 
            !userData.education?.length || 
            !userData.experience?.length;

        if (isMissingInfo) {
            // Thay vì window.confirm, ta set nội dung Toast đặc biệt
            showToastMsg(
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <span>Hồ sơ của bạn chưa hoàn thiện!</span>
                    <button 
                        onClick={() => navigate('/candidate/profile')}
                        style={{
                            background: '#2563EB', color: 'white', border: 'none',
                            padding: '4px 8px', borderRadius: '4px', cursor: 'pointer',
                            fontSize: '12px', fontWeight: 'bold'
                        }}
                    >
                        Cập nhật ngay
                    </button>
                </div>
            );
            return;
        }

        // 3. Nếu đã đủ thông tin, tiến hành logic ứng tuyển như cũ
        if (job.requiredAssessment) {
            setIsModalOpen(true);
        } else {
            const applyRes = await fetch(`${apiBaseUrl}/api/candidates`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify({
                    name: profile.fullName,
                    email: userData.email,
                    position: job.title,
                    jobId: job._id,
                    status: 'Mới'
                })
            });

            if (applyRes.ok) {
                setApplicationStatus('Mới');
                showToastMsg("Nộp đơn ứng tuyển thành công!");
            } else { 
                alert("Có lỗi xảy ra khi nộp đơn."); 
            }
        }
    } catch (err) { 
        console.error("Lỗi ứng tuyển:", err); 
    }
};

    const confirmStartTest = () => {
        const assessmentId = job.requiredAssessment._id || job.requiredAssessment;
        setIsModalOpen(false);
        navigate(`/candidate/tests/${assessmentId}`, { state: { jobId: id } });
    };

    // Helpers
    const timeAgo = (dateString, prefix = "Cập nhật") => { if (!dateString) return ''; const date = new Date(dateString); const now = new Date(); const seconds = Math.floor((now - date) / 1000); let interval = Math.floor(seconds / 31536000); if (interval >= 1) return `${prefix} ${interval} năm trước`; interval = Math.floor(seconds / 2592000); if (interval >= 1) return `${prefix} ${interval} tháng trước`; interval = Math.floor(seconds / 86400); if (interval >= 1) return `${prefix} ${interval} ngày trước`; return "Vừa xong"; };
    const getDisplayDate = () => job ? (job.updatedAt && job.updatedAt !== job.createdAt ? timeAgo(job.updatedAt) : timeAgo(job.createdAt)) : "";
    const formatDate = (dateString) => dateString ? new Date(dateString).toLocaleDateString('vi-VN') : 'Không giới hạn';
    const handleCompanyClick = () => { const companyId = job.createdBy?._id || job.createdBy; if (companyId) { const isCandidate = location.pathname.startsWith('/candidate'); navigate(isCandidate ? `/candidate/companies/${companyId}` : `/companies/${companyId}`); } };
    const handleShareJob = () => { navigator.clipboard.writeText(window.location.href); showToastMsg("Đã sao chép liên kết!"); };
    const handleScrollTo = (id, tab) => { setActiveTab(tab); document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); };

    if (loading) return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F3F4F6', color: '#6B7280' }}>
            <span className="material-symbols-outlined animate-spin" style={{ fontSize: 48, marginBottom: 16, color: '#2563EB' }}>sync</span>
            <p style={{ fontWeight: 500 }}>Đang tải thông tin...</p>
        </div>
    );

    if (!job) return <div>Không tìm thấy job</div>;

    // --- STEPPER RENDER ---
    const getStepStatus = (stepIndex) => {
        if (!applicationStatus) return stepIndex === 1 ? 'current' : 'pending';
        if (stepIndex === 1) return 'completed';
        
        // Bước 2: Bài Test
        if (stepIndex === 2) {
            if (['Mới', 'Đang làm bài'].includes(applicationStatus)) return 'current';
            if (['Chấm điểm xong', 'Phỏng vấn', 'Đạt', 'Từ chối'].includes(applicationStatus)) return 'completed';
        }
        
        // Bước 3: Phỏng vấn
        if (stepIndex === 3) {
            if (applicationStatus === 'Phỏng vấn') return 'current';
            if (applicationStatus === 'Đạt') return 'completed';
        }
        return 'pending';
    };

    const renderStep = (stepNumber, label, icon, subtext) => {
        const status = getStepStatus(stepNumber);
        let iconBg = '#F3F4F6', iconColor = '#6B7280', textClass = 'text-gray-500';

        if (status === 'completed') {
            iconBg = '#ECFDF5'; iconColor = '#059669'; textClass = 'text-gray-900 font-medium';
            icon = <span className="material-symbols-outlined" style={{ fontSize: 18 }}>check</span>;
        } else if (status === 'current') {
            iconBg = '#EFF6FF'; iconColor = '#2563EB'; textClass = 'text-blue-700 font-bold';
        }

        return (
            <div className="jd-step-item" style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 20 }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', background: iconBg, color: iconColor, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{icon}</div>
                <div>
                    <p className={textClass} style={{ margin: 0, fontSize: 14 }}>{label}</p>
                    <span style={{ fontSize: 12, color: '#9CA3AF' }}>{subtext}</span>
                </div>
            </div>
        );
    };

    const renderApplyButton = () => {
        if (!applicationStatus && isExpired) {
            return (
                <button disabled style={{ width: '100%', padding: '14px', borderRadius: 12, border: '1px solid #E5E7EB', background: '#F3F4F6', color: '#9CA3AF', fontWeight: 600, cursor: 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                    <span className="material-symbols-outlined" style={{ fontSize: 20 }}>event_busy</span>
                    Đã hết hạn nộp hồ sơ
                </button>
            );
        }
        const isLimitReached = usage?.plan === 'free' && (usage?.apply?.used >= usage?.apply?.limit);

        // 2. Chưa ứng tuyển (và còn hạn) -> Hiện nút Ứng tuyển
        if (!applicationStatus) {
            if (isLimitReached) {
                return (
                    <div style={{textAlign: 'center'}}>
                        <button disabled style={{ 
                            width: '100%', padding: '14px', borderRadius: 12, border: '1px solid #D1D5DB', 
                            background: '#E5E7EB', color: '#6B7280', fontWeight: 600, cursor: 'not-allowed', 
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 
                        }}>
                            <span className="material-symbols-outlined">lock</span>
                            Hết lượt ứng tuyển hôm nay (3/3)
                        </button>
                        <p onClick={() => setShowUpgradeModal(true)} style={{fontSize: 12, color: '#2563EB', marginTop: 8, cursor: 'pointer', textDecoration: 'underline'}}>
                            Nâng cấp để không giới hạn &gt;
                        </p>
                    </div>
                );
            }
            if (job.requiredAssessment) {
                return (
                    <button className="jd-btn-apply-big" onClick={() => setIsModalOpen(true)} style={{ background: 'linear-gradient(135deg, #2563EB 0%, #4F46E5 100%)', color: 'white', border: 'none', cursor: 'pointer', width: '100%', padding: '14px', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, fontWeight: 600, boxShadow: '0 4px 12px rgba(37,99,235,0.3)', transition: 'transform 0.2s' }}>
                        <span>Ứng tuyển & Làm Test</span> <IconArrowRightBig />
                    </button>
                );
            }
            return (
                <button className="jd-btn-apply-big" onClick={handleApply} style={{ background: 'linear-gradient(135deg, #2563EB 0%, #4F46E5 100%)', color: 'white', border: 'none', cursor: 'pointer', width: '100%', padding: '14px', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, fontWeight: 600, boxShadow: '0 4px 12px rgba(37,99,235,0.3)', transition: 'transform 0.2s' }}>
                    <span>Ứng tuyển ngay</span> <IconArrowRightBig />
                </button>
            );
        }

        // Trường hợp đã làm bài Test xong nhưng chưa có lịch phỏng vấn
        if (['Mới', 'Chấm điểm xong', 'Đang làm bài'].includes(applicationStatus)) {
            return (
                <button disabled style={{ width: '100%', padding: '14px', borderRadius: 12, border: '1px solid #FCD34D', background: '#FFFBEB', color: '#D97706', fontWeight: 600, cursor: 'not-allowed' }}>
                    <span className="material-symbols-outlined" style={{ fontSize: 20, verticalAlign: 'middle', marginRight: 8 }}>hourglass_empty</span>
                    Đang chờ kết quả
                </button>
            );
        }

        // Trường hợp được mời phỏng vấn
        if (applicationStatus === 'Phỏng vấn') {
            return (
                <button onClick={() => navigate('/candidate/my-interviews')} style={{ width: '100%', padding: '14px', borderRadius: 12, border: '1px solid #93C5FD', background: '#EFF6FF', color: '#2563EB', fontWeight: 600, cursor: 'pointer' }}>
                    <span className="material-symbols-outlined" style={{ fontSize: 20, verticalAlign: 'middle', marginRight: 8 }}>calendar_month</span>
                    Xem lịch phỏng vấn
                </button>
            );
        }
        if (applicationStatus === 'Từ chối') {
            return (
                <button disabled style={{ width: '100%', padding: '14px', borderRadius: 12, border: '1px solid #E5E7EB', background: '#F3F4F6', color: '#6B7280', fontWeight: 600, cursor: 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                    <span className="material-symbols-outlined" style={{ fontSize: 20 }}>cancel</span>
                    Hồ sơ không phù hợp
                </button>
            );
        }

        // 5. ✅ BỔ SUNG: Đã Trúng tuyển (Đạt)
        if (applicationStatus === 'Đạt') {
            return (
                <button disabled style={{ width: '100%', padding: '14px', borderRadius: 12, border: '1px solid #A7F3D0', background: '#ECFDF5', color: '#059669', fontWeight: 600, cursor: 'default', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                    <span className="material-symbols-outlined" style={{ fontSize: 20 }}>check_circle</span>
                    Đã trúng tuyển
                </button>
            );
        }
        return (
            <button className="jd-btn-apply-big" onClick={handleApply} style={{ background: 'linear-gradient(135deg, #2563EB 0%, #4F46E5 100%)', color: 'white', border: 'none', cursor: 'pointer', width: '100%', padding: '14px', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, fontWeight: 600, boxShadow: '0 4px 12px rgba(37,99,235,0.3)', transition: 'transform 0.2s' }}>
                <span>{job.requiredAssessment ? 'Ứng tuyển & Làm Test' : 'Ứng tuyển ngay'}</span> <IconArrowRightBig />
            </button>
        );
    };

    // ✅ APPLY PADDING-TOP & BACKGROUND HERE
    return (
        <div style={{ backgroundColor: '#F8FAFC', minHeight: '100vh', paddingTop: '120px', paddingBottom: '60px' }}>
            <div className="jd-container" style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 20px' }}>

                {/* BREADCRUMBS */}
                <div className="jd-breadcrumbs" style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#6B7280', marginBottom: 24 }}>
                    <Link to="/" style={{ textDecoration: 'none', color: '#6B7280' }}>Trang chủ</Link> <IconChevronRight />
                    <Link to="/jobs" style={{ textDecoration: 'none', color: '#6B7280' }}>Việc làm</Link> <IconChevronRight />
                    <span style={{ color: '#111827', fontWeight: 600 }}>{job.title}</span>
                </div>

                <div className="jd-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 24 }}>
                    {/* LEFT COLUMN */}
                    <div>
                        {/* Header Card */}
                        <div className="jd-card" style={{ background: 'white', borderRadius: 16, padding: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', marginBottom: 24 }}>
                            <div className="jd-header-top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
                                <div style={{ display: 'flex', gap: 16 }}>
                                    <div style={{ width: 64, height: 64, background: '#F3F4F6', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, fontWeight: 700, color: '#4B5563' }}>
                                        {job.companyName ? job.companyName.charAt(0).toUpperCase() : 'C'}
                                    </div>
                                    <div>
                                        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', margin: '0 0 4px' }}>{job.title}</h1>
                                        <div style={{ fontSize: 14, color: '#6B7280' }}>
                                            <span onClick={handleCompanyClick} style={{ cursor: 'pointer', fontWeight: 500, color: '#4B5563' }}>{job.companyName}</span>
                                            <span style={{ margin: '0 6px' }}>•</span>
                                            <span>{getDisplayDate()}</span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <button onClick={handleSaveJob} style={{ width: 40, height: 40, borderRadius: '50%', border: '1px solid #E5E7EB', background: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: isSaved ? '#EF4444' : '#6B7280' }}>
                                        <IconHeart filled={isSaved} />
                                    </button>
                                    <button onClick={handleShareJob} style={{ width: 40, height: 40, borderRadius: '50%', border: '1px solid #E5E7EB', background: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#6B7280' }}>
                                        <IconShare />
                                    </button>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                <div style={{ background: '#ECFDF5', color: '#059669', padding: '6px 12px', borderRadius: 8, fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}><IconMoney /> {job.salary}</div>
                                <div style={{ background: '#F3F4F6', color: '#4B5563', padding: '6px 12px', borderRadius: 8, fontSize: 13, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}><IconMap /> {job.location}</div>
                                <div style={{ background: '#F3F4F6', color: '#4B5563', padding: '6px 12px', borderRadius: 8, fontSize: 13, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}><IconBriefcase /> {job.type}</div>
                                <div style={{ background: '#F3F4F6', color: '#4B5563', padding: '6px 12px', borderRadius: 8, fontSize: 13, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}><IconLaptop /> Hybrid</div>
                            </div>
                        </div>

                        {/* Content Tabs */}
                        <div className="jd-card" style={{ background: 'white', borderRadius: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                            <div style={{ display: 'flex', borderBottom: '1px solid #E5E7EB', overflowX: 'auto' }}>
                                {[
                                    { id: 'desc', label: 'Mô tả công việc' }, 
                                    { id: 'req', label: 'Yêu cầu' }, 
                                    { id: 'ben', label: 'Quyền lợi' },
                                    { id: 'ai_match', label: 'Job-matching', icon: true }
                                ].map(tab => (
                                    <div key={tab.id} onClick={() => handleTabClick(tab.id)} style={{ 
                                        padding: '16px 24px', cursor: 'pointer', fontSize: 14, fontWeight: 600, whiteSpace: 'nowrap',
                                        color: activeTab === tab.id ? '#2563EB' : '#6B7280', 
                                        borderBottom: activeTab === tab.id ? '2px solid #2563EB' : 'none',
                                        display: 'flex', alignItems: 'center', gap: 6
                                    }}>
                                       {tab.icon } {tab.label}
                                       {tab.id === 'ai_match' && usage?.plan === 'free' && <span className="text-[10px] bg-yellow-100 text-yellow-700 px-1.5 rounded ml-1">PRO</span>}
                                    </div>
                                ))}
                            </div>

                            <div style={{ padding: '32px' }}>
                                
                                {/* ✅ CASE 1: AI MATCH (HIỂN THỊ RIÊNG) */}
                                {activeTab === 'ai_match' ? (
                                    <div className="animate-fadeIn">
                                        <h3 style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                                            PHÂN TÍCH MỨC ĐỘ PHÙ HỢP
                                        </h3>

                                        {usage?.plan === 'free' ? (
                                            <div style={{ textAlign: 'center', padding: '40px', background: '#F9FAFB', borderRadius: 12 }}>
                                                <span className="material-symbols-outlined" style={{ fontSize: 48, color: '#F59E0B' }}>lock</span>
                                                <h4 style={{ fontWeight: 'bold', marginTop: 12 }}>Tính năng dành cho gói PRO/PREMIUM</h4>
                                                <p style={{ fontSize: 14, color: '#6B7280', margin: '8px 0 20px' }}>Nâng cấp tài khoản để xem AI đánh giá khả năng trúng tuyển của bạn.</p>
                                                <button onClick={() => setShowUpgradeModal(true)} style={{ padding: '10px 20px', background: '#2563EB', color: 'white', borderRadius: 8, border: 'none', fontWeight: 600, cursor: 'pointer' }}>Nâng cấp ngay</button>
                                            </div>
                                        ) : aiLoading ? (
                                            <div style={{ textAlign: 'center', padding: '40px' }}>
                                                <span className="material-symbols-outlined animate-spin" style={{ fontSize: 32, color: '#2563EB' }}>sync</span>
                                                <p style={{ fontSize: 14, color: '#6B7280', marginTop: 8 }}>AI đang phân tích hồ sơ của bạn...</p>
                                            </div>
                                        ) : aiMatch ? (
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                                                {/* Score Circle */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 24, padding: 20, background: '#F0FDFA', borderRadius: 12, border: '1px solid #CCFBF1' }}>
                                                    <div style={{ position: 'relative', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', background: `conic-gradient(#059669 ${aiMatch.score}%, #E5E7EB 0)` }}>
                                                        <div style={{ position: 'absolute', width: 68, height: 68, background: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: 20, color: '#059669' }}>
                                                            {aiMatch.score}%
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h4 style={{ fontWeight: 'bold', color: '#065F46', fontSize: 18 }}>{aiMatch.verdict}</h4>
                                                        <p style={{ fontSize: 14, color: '#047857' }}>Dựa trên kỹ năng và kinh nghiệm trong hồ sơ của bạn.</p>
                                                    </div>
                                                </div>
                                                {/* Grid Pros/Cons */}
                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                                                    <div style={{ background: '#ECFDF5', padding: 16, borderRadius: 12 }}>
                                                        <h5 style={{ fontWeight: 'bold', color: '#059669', marginBottom: 8 }}>👍 Điểm mạnh</h5>
                                                        <ul style={{ paddingLeft: 20, fontSize: 14, color: '#064E3B' }}>{aiMatch.pros.map((p, i) => <li key={i}>{p}</li>)}</ul>
                                                    </div>
                                                    <div style={{ background: '#FEF2F2', padding: 16, borderRadius: 12 }}>
                                                        <h5 style={{ fontWeight: 'bold', color: '#DC2626', marginBottom: 8 }}>⚠️ Cần cải thiện</h5>
                                                        <ul style={{ paddingLeft: 20, fontSize: 14, color: '#7F1D1D' }}>{aiMatch.cons.map((c, i) => <li key={i}>{c}</li>)}</ul>
                                                    </div>
                                                </div>
                                                <div style={{ background: '#EFF6FF', padding: 16, borderRadius: 12 }}>
                                                    <h5 style={{ fontWeight: 'bold', color: '#1E40AF', marginBottom: 8 }}>💡 Lời khuyên</h5>
                                                    <p style={{ fontSize: 14, color: '#1E3A8A' }}>{aiMatch.advice}</p>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : (
                                    // ✅ CASE 2: CÁC TAB CÒN LẠI -> HIỂN THỊ TẤT CẢ (STACKED)
                                    <div className="animate-fadeIn">
                                        <div id="section-desc" style={{ marginBottom: 32 }}>
                                            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 16 }}>TRÁCH NHIỆM CÔNG VIỆC</h3>
                                            <ul style={{ paddingLeft: 20, color: '#4B5563', lineHeight: 1.6, fontSize: 15 }}>{job.description && job.description.map((item, i) => <li key={i} style={{ marginBottom: 8 }}>{item}</li>)}</ul>
                                        </div>
                                        <div id="section-req" style={{ marginBottom: 32 }}>
                                            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 16 }}>YÊU CẦU CHUYÊN MÔN</h3>
                                            <ul style={{ paddingLeft: 20, color: '#4B5563', lineHeight: 1.6, fontSize: 15 }}>{job.requirements && job.requirements.map((item, i) => <li key={i} style={{ marginBottom: 8 }}>{item}</li>)}</ul>
                                        </div>
                                        <div id="section-ben">
                                            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 16 }}>QUYỀN LỢI</h3>
                                            <ul style={{ paddingLeft: 20, color: '#4B5563', lineHeight: 1.6, fontSize: 15 }}>{job.benefits && job.benefits.map((item, i) => <li key={i} style={{ marginBottom: 8 }}>{item}</li>)}</ul>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT COLUMN */}
                    <div style={{ position: 'sticky', top: 120 }}>
                        {/* Process Card */}
                        <div style={{ background: 'white', borderRadius: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', marginBottom: 24, overflow: 'hidden' }}>
                            <div style={{ padding: '20px 24px', borderBottom: '1px solid #F3F4F6' }}>
                                <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0, color: '#111827' }}>Quy trình ứng tuyển</h3>
                                <p style={{ fontSize: 12, color: '#6B7280', margin: '4px 0 0' }}>Theo dõi trạng thái hồ sơ của bạn</p>
                            </div>
                            <div style={{ padding: 24 }}>
                                <div style={{ position: 'relative' }}>
                                    {/* Line connector */}
                                    <div style={{ position: 'absolute', top: 20, bottom: 40, left: 19, width: 2, background: '#F3F4F6', zIndex: 0 }}></div>

                                    <div style={{ position: 'relative', zIndex: 1 }}>
                                        {renderStep(1, "Nộp CV / Hồ sơ", <IconUpload />, "Xét duyệt trong 24h")}

                                        {/* ✅ CHỈ HIỆN BÀI TEST NẾU JOB CÓ YÊU CẦU */}
                                        {job.requiredAssessment && renderStep(2, "Làm bài Test năng lực", <IconQuiz />, "Kiểm tra kỹ năng")}

                                        <div style={{ marginBottom: 0 }}>
                                            {/* ✅ TỰ ĐỘNG ĐỔI SỐ THỨ TỰ BƯỚC CUỐI */}
                                            {renderStep(job.requiredAssessment ? 3 : 2, "Phỏng vấn", <IconUsers />, "Trao đổi trực tiếp")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: '0 24px 24px' }}>
                                {renderApplyButton()}
                                <p style={{ textAlign: 'center', fontSize: 12, color: '#9CA3AF', marginTop: 12 }}>Hạn nộp: <span style={{ color: '#4B5563', fontWeight: 600 }}>{formatDate(job.endDate)}</span></p>
                            </div>
                        </div>

                        {/* Company Widget */}
                        <div style={{ background: 'white', borderRadius: 16, padding: 16, display: 'flex', alignItems: 'center', gap: 12, border: '1px solid #E5E7EB' }}>
                            <div style={{ width: 40, height: 40, background: '#EFF6FF', color: '#2563EB', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><IconDomain /></div>
                            <div>
                                <p style={{ fontWeight: 700, fontSize: 14, color: '#111827', margin: 0 }}>{job.companyName}</p>
                                <span onClick={handleCompanyClick} style={{ fontSize: 12, color: '#2563EB', cursor: 'pointer', fontWeight: 500 }}>Xem trang công ty</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CUSTOM MODAL */}
            {isModalOpen && (
                <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', animation: 'fadeIn 0.2s' }}>
                    <div style={{ background: 'white', width: '90%', maxWidth: 450, borderRadius: 16, overflow: 'hidden', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', animation: 'slideUp 0.3s ease-out' }}>
                        <div style={{ padding: '16px 24px', borderBottom: '1px solid #E5E7EB', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ fontSize: 18, fontWeight: 600, margin: 0, color: '#111827' }}>Xác nhận bắt đầu</h3>
                            <button onClick={() => setIsModalOpen(false)} style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', color: '#6B7280' }}>×</button>
                        </div>
                        <div style={{ padding: '32px 24px', textAlign: 'center' }}>
                            <div style={{ fontSize: 48, marginBottom: 16 }}>📝</div>
                            <h4 style={{ fontSize: 18, fontWeight: 700, color: '#111827', margin: '0 0 8px' }}>Bài kiểm tra chính thức!</h4>
                            <p style={{ color: '#4B5563', fontSize: 14, margin: '4px 0' }}>Bạn chỉ có <strong>1 cơ hội</strong> để làm bài.</p>
                            <p style={{ color: '#4B5563', fontSize: 14, margin: '4px 0' }}>Kết quả sẽ được gửi trực tiếp đến nhà tuyển dụng.</p>
                            <p style={{ color: '#EF4444', fontSize: 13, marginTop: 16, fontWeight: 500 }}>⚠️ Đảm bảo kết nối mạng ổn định.</p>
                        </div>
                        <div style={{ padding: '16px 24px', background: '#F9FAFB', borderTop: '1px solid #E5E7EB', display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                            <button onClick={() => setIsModalOpen(false)} style={{ padding: '10px 20px', border: '1px solid #D1D5DB', background: 'white', borderRadius: 8, cursor: 'pointer', fontWeight: 600, color: '#374151' }}>Để sau</button>
                            <button onClick={confirmStartTest} style={{ padding: '10px 20px', background: '#2563EB', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>Bắt đầu ngay</button>
                        </div>
                    </div>
                </div>
            )}
            <UpgradeRequestModal 
                isOpen={showUpgradeModal} 
                onClose={() => setShowUpgradeModal(false)}
                title="Hết lượt ứng tuyển"
                message="Gói FREE giới hạn 3 lượt ứng tuyển/ngày. Nâng cấp PRO để ứng tuyển không giới hạn!"
            />

            {toast && <Toast message={toast} onClose={() => setToast(null)} />}

            <style>{`
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
                @keyframes slideUpToast { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
                @media (max-width: 768px) { .jd-grid { grid-template-columns: 1fr !important; } }
            `}</style>
        </div>
    );
}